// Supply 360 Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ── Sticky header shadow
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 24px rgba(0,0,0,0.35)'
        : '0 2px 20px rgba(0,0,0,0.25)';
    });
  }

  // ── Mobile menu toggle
  var toggle = document.getElementById('menu-toggle');
  var mobileNav = document.getElementById('mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.style.display === 'block';
      mobileNav.style.display = open ? 'none' : 'block';
      toggle.setAttribute('aria-expanded', !open);
    });
  }

  // ── File upload label
  var fileInput = document.getElementById('logo-upload');
  var fileLabel = document.getElementById('upload-label');
  if (fileInput && fileLabel) {
    fileInput.addEventListener('change', function () {
      if (this.files && this.files.length > 0) {
        var names = Array.from(this.files).map(function(f){ return f.name; }).join(', ');
        fileLabel.querySelector('strong').textContent = '✓ ' + names;
        fileLabel.style.borderColor = '#2E7D32';
        fileLabel.style.background = 'rgba(46,125,50,0.05)';
      }
    });
  }

  // ── Quote form — Shopify handles the actual submission (sends to your
  //    Notifications sender email). We just show a sending state on submit.
  var form = document.getElementById('quote-form');
  if (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('.form-submit, .form-submit-btn');
      if (btn) { btn.textContent = 'Sending your request…'; btn.style.opacity = '0.75'; btn.disabled = true; }
    });
  }

  // ── Product filter tabs
  var filterBtns = document.querySelectorAll('[data-filter]');
  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = this.getAttribute('data-filter');
      filterBtns.forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      document.querySelectorAll('[data-category]').forEach(function(card) {
        if (target === 'all' || card.getAttribute('data-category') === target) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });

});
